/* eslint-disable react/jsx-indent */
/* eslint-disable prettier/prettier */
import React from 'react'
import PropTypes from 'prop-types'
import { MdChevronRight } from 'react-icons/md'
import { Link } from 'react-router-dom'
import Section from '../Section/Section'
import Flex from '../Flex/Flex'
import Tag from '../Tag/Tag'
import BoxIndicatorWithFilter from '../BoxIndicatorWithFilter/BoxIndicatorWithFilter'
import Text from '../Text/Text'
import styles from './sectionIndicatorsManagerial.module.scss'

const SectionIndicatorsManagerial = (props) => {
  const {
    seeAllLink,
    filters,
    indicators,
    onClickFilter,
    filterActive,
    handleIndicatorWithFilter,
    customEmptyMessage
  } = props

  return (
    <Section
      title="Indicadores Gerenciais"
      Actions={
        indicators.length > 0
          ? () => (
              <Link to={seeAllLink}>
                <div className={styles.flexHeader}>
                  <Text size="xxs" color="gray" variation="dark" font="custom">
                    ver todos
                  </Text>
                  <MdChevronRight color="#4d4d4d" />
                </div>
              </Link>
            )
          : null
      }
    >
      <Flex column flex={indicators.length === 0 ? '1' : null}>
        <div className={styles.flexFilters}>
          {filters.map((item) => (
            <Tag
              white
              active={item.id === filterActive?.id}
              size="xs"
              key={item.id}
              text={item.title}
              id={item.id}
              onClick={onClickFilter}
            />
          ))}
        </div>

        {indicators.length > 0 ? (
          <div className={styles.grid}>
            {indicators.map((indicator) => (
              <BoxIndicatorWithFilter
                key={indicator.identifier}
                indicator={indicator}
                onClick={handleIndicatorWithFilter}
                height="100%"
              />
            ))}
          </div>
        ) : (
          <Flex
            alignItems="center"
            justifyContent="center"
            margin="32px 0px 0px"
            flex="1"
          >
            <Text size="xxs" color="gray" font="custom">
              {customEmptyMessage ?? 'Indicador não encontrado.'}
            </Text>
          </Flex>
        )}
      </Flex>
    </Section>
  )
}

SectionIndicatorsManagerial.defaultProps = {
  filters: [],
  indicators: [],
  onClickFilter: null,
  handleIndicatorWithFilter: null,
  filterActive: {},
  customEmptyMessage: null
}

SectionIndicatorsManagerial.propTypes = {
  seeAllLink: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string
    })
  ),
  indicators: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ),
  filterActive: PropTypes.shape({
    id: PropTypes?.number
  }),
  onClickFilter: PropTypes.func,
  handleIndicatorWithFilter: PropTypes.func,
  customEmptyMessage: PropTypes.string
}

export default SectionIndicatorsManagerial
